class jsLocalStorage {

	constructor(key, json) {
		this.key = key;
		this.json = json;
	}
	// JSONを引数指定したkeyにローカルストレージ保存
	setStorageJson(key, json) {
		return localStorage.setItem(key, JSON.stringify(json));
	}
	// JSONを引数指定したkeyよりローカルストレージ取得
	getStorageJson(key) {
		var json = localStorage.getItem(key);
		return JSON.parse(json);
	}
	// 引数指定したkeyのデータを削除
	removeStorage(key) {
		return localStorage.removeItem(key);
	}

}
export default {jsLocalStorage}